import { MINIMUM_HALL_ID, MAXIMUM_HALL_ID } from "../../configs/HALL_ID_CONFIG";
import { LEFT, RIGHT } from "../../configs/ARROWS_DIRECTION_CONFIG";
import { updateHallURL } from "../../helpers/updateBoothURL";
import { useRouterStore } from "../../store/useRouterStore";
import { HALL_ID } from "../../configs/HALLS_CONFIG";
import { useEffect } from "react";
import Router from "next/router";
import { useThree } from "@react-three/fiber";
import {
  animateLeftHallChange,
  animateRightHallChange,
} from "../../animations/animateHallChange";

const ChangeHallFiberComponent = () => {
  const { hallID, arrowDirection, setArrowDirection, lastTriggeredAt } =
    useRouterStore();

  const { camera } = useThree();

  useEffect(() => {
    if (!lastTriggeredAt || arrowDirection === "" || !hallID) return;
    if (Router.query[HALL_ID] && !Router.query.id) {
      const id = Number(hallID);
      if (arrowDirection === LEFT && id > MINIMUM_HALL_ID) {
        animateLeftHallChange(camera, () => {
          updateHallURL(String(id === MINIMUM_HALL_ID + 1 ? id : id - 1));
          setArrowDirection("");
        });
      }
      if (arrowDirection === RIGHT && id < MAXIMUM_HALL_ID) {
        animateRightHallChange(camera, () => {
          updateHallURL(String(id === MAXIMUM_HALL_ID - 1 ? id : id + 1));
          setArrowDirection("");
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastTriggeredAt, arrowDirection, hallID, Router]);
  return <mesh></mesh>;
};

export default ChangeHallFiberComponent;
